import { mapActions, mapGetters, mapState } from 'vuex';
import {
  UX_OPTIONS_COLOR_THEME,
  UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING,
} from '@/components/account/settings/settings';
import smallModal from '@/components/generics/modal/small/small.vue';
import env from '@/env';
import log from '@/logger';
import loaderMixin from '@/mixins/loader';
import { APP_MOBILE_ORDERBOOK_DISPLAY, APP_PRICE_DISPLAY, UX_CATEGORY } from '@/store/modules/app';

export default {
  mixins: [loaderMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  components: {
    'small-modal': smallModal,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('app', [
      'settingShowOdds',
      'settingOrderbookCollapsed',
      'settingColorPalette',
      'settingMobileLayout',
      'settingDirectionButtonVersion',
      'settingTheme',
    ]),
    settingsModalOptions() {
      const options = UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING.filter(
        (setting) =>
          this.isLayoutMobile || setting.key !== UX_CATEGORY.UXSettingMobileContractLayout,
      );
      return env.DARK_MODE_ENABLED ? [...options, UX_OPTIONS_COLOR_THEME] : options;
    },
  },
  methods: {
    ...mapActions('app', [
      'setSettingShowOdds',
      'setSettingOrderbookCollapsed',
      'setSettingColorPalette',
      'setSettingMobileLayout',
      'setSettingDirectionButtonVersion',
      'setSettingTheme',
    ]),
    close() {
      this.$emit('update:modelValue', false);
    },
    isOptionDisabled(option) {
      return !!option.disabled;
    },
    onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }
      this.setSettingValue(category, option.key);
    },
    setSettingValue(category, key) {
      if (category === UX_CATEGORY.UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === APP_PRICE_DISPLAY.ODDS)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingDirectionButtonVersion) {
        this.loaderAdd(document.body);
        this.setSettingDirectionButtonVersion(key)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingColorTheme) {
        this.loaderAdd(document.body);
        this.setSettingTheme(key)
          .catch((error) => log.error('Request failed.', error))
          .finally(() => this.loaderRemove(document.body));
      }
    },
    isSelected(category, key) {
      switch (category) {
        case UX_CATEGORY.UXSettingPriceDisplay:
          return this.settingShowOdds === (key === APP_PRICE_DISPLAY.ODDS);
        case UX_CATEGORY.UXSettingIsOBCollapsedOnOS:
          return (
            this.settingOrderbookCollapsed === (key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED)
          );
        case UX_CATEGORY.UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case UX_CATEGORY.UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        case UX_CATEGORY.UXSettingDirectionButtonVersion:
          return this.settingDirectionButtonVersion === key;
        case UX_CATEGORY.UXSettingColorTheme:
          return this.settingTheme === key;
        default:
          return false;
      }
    },
  },
};
